import React from "react";
import { LoadPhase, SkeletonCard, skeletonRows } from "../../../components/ui";

/** As many cards as there are cycles on sale. Two is what the endpoint has
 *  answered with since there has been an endpoint; a third would land as a
 *  third card and this would be one row short for a moment, which is a cheaper
 *  wrong than a column of blocks for plans nobody sells. */
const PLACEHOLDER_CARDS = 2;

/** The height a plan card stands at — its price, what it includes, and the
 *  button at its foot. The grid stretches both to the taller of the two. */
const CARD_FOOTPRINT = "h-full min-h-[440px] 3xl:min-h-[480px]";

export interface PlansSkeletonProps {
  /**
   * How long the price list has been coming. Only `slow` draws the cards'
   * shape; while it is merely `waiting` the space is empty, so a list that
   * arrives quickly is never preceded by a screenful of blocks.
   */
  phase: LoadPhase;
}

/**
 * The price list while it is still on its way.
 *
 * Two tall blocks land where two tall cards will, so the page does not jump
 * when the figures arrive — one block per card, not one for every tick and line
 * inside it.
 *
 * Hidden from screen readers, all of it. These are not plans, and a page that
 * announced two of them would be answering a question it does not yet know the
 * answer to; the section says "Loading" in words instead.
 */
const PlansSkeleton: React.FC<PlansSkeletonProps> = ({ phase }) => {
  if (phase !== "slow") {
    // Nothing at all while the wait is too short to notice — but the grid it
    // sits in keeps its own gaps, so what lands does not shift the page.
    return null;
  }

  return (
    <>
      {skeletonRows(PLACEHOLDER_CARDS).map((card) => (
        <SkeletonCard key={card} className={CARD_FOOTPRINT} />
      ))}
    </>
  );
};

export default PlansSkeleton;
